import {slideUp} from "es6-slide-up-down";

export default function () {

    const hamburger = document.querySelector('.js-hamburger');
    const submenuToggles = document.querySelectorAll('.js-toggle');
    const navSelect = document.querySelector('[data-nav-select]');

    hamburger.addEventListener("click", () => {
        hamburger.classList.toggle('is-active');
        document.querySelector('.js-main-menu').classList.toggle('is-active');
    });

    submenuToggles.forEach(function (submenuToggle, index) {
        submenuToggle.addEventListener("click", (e) => {
            if (submenuToggle.classList.contains('is-active')) {
                submenuToggle.classList.remove('is-active');
                submenuToggle.parentElement.classList.remove('is-active');
                submenuToggle.nextElementSibling.classList.remove('is-active');
            } else {
                // close eveything first
                const activeItems = document.querySelectorAll('.header__navigation .is-active');
                for (const item of activeItems) {
                    item.classList.remove('is-active');
                }


                submenuToggle.classList.add('is-active');
                submenuToggle.parentElement.classList.add('is-active');
                submenuToggle.nextElementSibling.classList.add('is-active');
            }
        });
    });

    if (navSelect) {
        navSelect.addEventListener('change', () => {
            window.location.href = navSelect.value;
        });
    }

}
